import useFeatureFlags from "../../Hooks/useFeatureFlags";
import useUserAccess from "../../Hooks/useUserAccess";
import {Navigate, Route, Routes} from "react-router-dom";
import RequireAuth from "../Permission/RequireAuth";
import {UserRoles} from "../../Constants/userRoles";
import AoLeadsLayout from "../../Layouts/AoLeads/AoLeadsLayout";
import AoLeadEditContainer from "../../Containers/Leads/AoLeadEditContainer";
import AOLeadDetailsContainer from "../../Containers/Leads/AoLeadDetailsContainer";
import InternalLeadEditContainer from "../../Containers/Leads/InternalLeadEditContainer";
import InternalLeadDetailsContainer from "../../Containers/Leads/InternalLeadDetailsContainer";
import InternalLeadsContainer from "../../Containers/Leads/InternalLeadsContainer";
import SettingsLayout from "../../Layouts/Settings/SettingsLayout";
import TerminationReasonsLayout from "../Layout/InternalCustomerAdmin/TerminationReasonsLayout";
import AdminUsersContainer from "../../Containers/Settings/AdminUsersContainer";
import AdminusersEditContainer from "../../Containers/Settings/AdminUsersEditContainer";
import BokaMeraAdminContainer from "../../Containers/Settings/BokaMeraAdminContainer";
import AdminBudgetContainer from "../../Containers/Settings/AdminBudgetContainer";
import AdminEditBudgetContainer from "../../Containers/Settings/AdminEditBudgetContainer";
import SettingsCompensationContainer from "../../Containers/Settings/SettingsCompensationContainer";
import SettingsCompensationEditContainer from "../../Containers/Settings/SettingsCompensationEditContainer";
import CustomerInfoTypesContainer from "../../Containers/Settings/CustomerInfoTypesContainer";
import CustomerInfoTypesEditContainer from "../../Containers/Settings/CustomerInfoTypesEditContainer";
import EditProductVersionContainer from "../../Containers/EditProductVersionContainer";
import EloquaEditContainer from "../../Containers/Settings/EloquaEditContainer";
import EloquaDefinitionsContainer from "../../Containers/Settings/EloquaDefinitionsContainer";
import EmailTemplatesContainer from "../../Containers/Settings/EmailTemplatesContainer";
import EmailTemplateEditContainer from "../../Containers/Settings/EmailTemplateEditContainer";
import FeedbackContainer from "../../Containers/FeedbackContainer";
import HittaByraContainer from "../../Containers/Settings/HittaByraContainer";
import HittaByraEditContainer from "../../Containers/Settings/HittaByraEditContainer";
import HittaByraAddDuplicateContainer from "../../Containers/Settings/HittaByraAddDuplicateContainer";
import HittaPartnerContainer from "../../Containers/Settings/HittaPartnerContainer";
import HittaPartnerEditContainer from "../../Containers/Settings/HittaPartnerEditContainer";
import LeadsListsContainer from "../../Containers/Settings/LeadsListsContainer";
import OrderApprovalRequestsContainer from "../../Containers/Settings/OrderApprovalRequestsContainer";
import OrderApprovalRequestsEditContainer from "../../Containers/Settings/OrderApprovalRequestsEditContainer";
import QuotationFaqContainer from "../../Containers/Settings/QuotationFaqContainer";
import ReleaseNewsContainer from "../../Containers/Settings/ReleaseNewsContainer";
import ReleaseNewsEditContainer from "../../Containers/Settings/ReleaseNewsEditContainer";
import WorkerJobsContainer from "../../Containers/Settings/WorkerJobsContainer";
import FeatureFlagsContainer from "../../Containers/Settings/FeatureFlagsContainer";
import VossFeatureFlagsContainer from "../../Containers/Settings/Voss/VossFeatureFlagsContainer";
import SystemActionLogContainer from "../../Containers/Settings/SystemActionLogContainer";
import TargetGroupsLayout from "../Layout/Voss/TargetGroupsLayout";
import AppConfigContainer from "../../Containers/Settings/AppConfigContainer";
import InvoicingContainer from "../../Containers/Settings/Voss/InvoicingContainer";
import {FeatureFlags} from "../../Utils/featureFlags";
import DiscountAgreementsLayout from "../Layout/Voss/DiscountAgreementsLayout";
import DiscountLayout from "../Layout/DiscountLayout";
import PriceAdjustmentLayout from "../Layout/Voss/PriceAdjustmentLayout";
import PackagesLayout from "../Layout/Voss/PackagesLayout";
import PriceSimulationLayout from "../Layout/PriceSimulation/PriceSimulationLayout";
import routes from "../../Constants/routes";
import Logout from "../Logout";
import CustomerLayout from "../../Layouts/Customer/CustomerLayout";
import CustomerContainer from "../../Containers/CustomerContainer";
import {MainContainer} from "../../Containers/Customer/MainContainer";
import customerRoutes from "../../Constants/Customer/customerRoutes";
import AppointmentsContainer from "../../Containers/Customer/AppointmentsContainer";
import CustomerAppointmentFormContainer from "../../Containers/Customer/CustomerAppointmentFormContainer";
import DiscountsContainer from "../../Containers/Customer/DiscountsContainer";
import SubscriptionsDiscountContainer from "../../Containers/Customer/VOSS/Discounts/SubscriptionsDiscountContainer";
import AdminFormsContainer from "../../Containers/Customer/AdminFormsContainer";
import EducationsLayout from "../../Containers/Customer/EducationsLayout";
import OrderConfirmationContainer from "../../Containers/Order/OrderConfirmationContainer";
import InvoicesContainer from "../../Containers/Customer/InvoicesContainer";
import CustomerTransactionsContainer from "../../Containers/Customer/CustomerTransactionsContainer";
import ConsultingContainer from "../../Containers/Customer/ConsultingContainer";
import SendDesktopVersionContainer from "../../Containers/Customer/SendDesktopVersionContainer";
import CustomerLeadsContainer from "../../Containers/Customer/CustomerLeadsContainer";
import RelatedCustomersContainer from "../../Containers/Customer/RelatedCustomersContainer";
import CompensationContainer from "../../Containers/Customer/CompensationContainer";
import CustomerEmailsContainer from "../../Containers/Customer/CustomerEmailsContainer";
import OrderPlacementContainer from "../../Containers/OrderPlacement/OrderPlacementContainer";
import InyettContainer from "../../Containers/Customer/InyettContainer";
import MyAppointmentsLayout from "../Layout/MyAppointmentsLayout";
import MyActionLogLayout from "../Layout/MyActionLogLayout";
import EmailHistory from "../../Containers/Customer/EmailHistoryContainer";
import LeadsLayout from "../Layout/LeadsLayout";
import UserSignatureContainer from "../../Containers/UserSignatureContainer";
import MyStatsContainer from "../../Containers/MyStatsContainer";
import ProductOverviewContainer from "../../Containers/ProductOverviewContainer";
import VersionArchive from "../VersionArchive";
import VersionArchiveDetails from "../VersionArchiveDetails";
import CustomerDirectoryContainer from "../../Containers/CustomerDirectoryContainer";
import CustomerDirectoryEditContainer from "../../Containers/CustomerDirectoryEditContainer";
import FileBoxContainer from "../../Containers/FileBox/FileBoxContainer";
import FileBoxTicketDetailsContainer from "../../Containers/FileBox/FileBoxTicketDetailsContainer";
import FileBoxCreateTicketContainer from "../../Containers/FileBox/FileBoxCreateTicketContainer";
import StatusContainer from "../../Containers/StatusContainer";
import BankruptcyTerminationContainer from "../../Containers/BankruptcyTerminationContainer";
import BankruptcyTerminationDetailContainer from "../../Containers/BankruptcyTerminationDetailContainer";
import VonEditEmployeeFormContainer from "../../Containers/Customer/VON/Employee/VonEditEmployeeFormContainer";
import CollaborationsContainer from "../../Containers/Customer/Collaborations/CollaborationsContainer";
import VonEmployeesContainer from "../../Containers/Customer/VON/VonEmployeesContainer";
import VonEmployees from "../Customer/VON/Employee/VonEmployees";
import SearchContainer from "../../Containers/SearchContainer";
import VonAdministerLicenseFormContainer from "../../Containers/Customer/VON/Licenses/VonAdministerLicenseFormContainer";
import CustomerSubscriptionContainer from "../../Containers/Customer/VOSS/Subscriptions/CustomerSubscriptionContainer";
import React from "react";
import CustomerLoggingContainer from "../../Containers/Customer/Logging/CustomerLoggingContainer";
import settingsRoutes from "../../Constants/Settings/settingsRoutes";
import GdprContainer from "../../Containers/Settings/gdpr/GdprContainer";


function AuthenticatedRoutes ( {  } ) {
    const {isFeatureEnabled} = useFeatureFlags();
    const {hasAdminAccess} = useUserAccess();

    return <Routes>
        <Route element={<RequireAuth.RequireReadOnlyAuth roles={[UserRoles.Spcs]}/>}>
            <Route path={'/search'} element={<SearchContainer/>}/>
            <Route path={routes.editSignature} element={<UserSignatureContainer/>}/>
            <Route path={routes.myStats} element={<MyStatsContainer/>}/>
            <Route path={routes.feedback} element={<FeedbackContainer/>}/>
            <Route path={'/leads/*'} element={<LeadsLayout/>}/>
            <Route path={'/my-appointments/*'} element={<MyAppointmentsLayout/>}/>
            <Route path={routes.myActions} element={<MyActionLogLayout/>}/>
            {/*<Route path={'/quotation/*'} element={<QuotationLayout/>}/>*/}
            <Route path={"/internal-leads/*"} element={<AoLeadsLayout/>}>
                <Route element={<RequireAuth.RequireReadWriteAuth roles={[UserRoles.AOLeads]}/>}>
                    <Route path={'ao-leads/edit/:leadId'} element={<AoLeadEditContainer/>}/>
                </Route>
                <Route path={'ao-leads/:leadId'} element={<AOLeadDetailsContainer/>}/>
                <Route element={<RequireAuth.RequireReadWriteAuth roles={[UserRoles.AOLeads]}/>}>
                    <Route path={'edit/:leadId'} element={<InternalLeadEditContainer/>}/>
                </Route>
                <Route path={':leadId'} element={<InternalLeadDetailsContainer/>}/>
                <Route index element={<InternalLeadsContainer/>}/>
            </Route>
            <Route path={routes.productOverview} element={<ProductOverviewContainer/>}/>
            <Route element={<RequireAuth.RequireReadWriteAuth roles={[UserRoles.AOSales]}/>}>
                <Route path={routes.customerDirectoryContainer} element={<CustomerDirectoryContainer/>}/>
                <Route path={'/customer-directory/:customerId'} element={<CustomerDirectoryEditContainer/>}/>
            </Route>
            <Route path={'/version-archive/'} element={<VersionArchive/>}/>
            <Route path={'/version-archive/:versionId'} element={<VersionArchiveDetails/>}/>


            <Route path={"/customer/:pathId"} element={<CustomerLayout/>}>
                <Route element={<CustomerContainer/>}>
                    <Route index element={<MainContainer/>}/>
                    <Route path={"appointments"}>
                        <Route index element={<AppointmentsContainer/>}/>
                        <Route path={'new'} element={<CustomerAppointmentFormContainer/>}/>
                        <Route path={':appointmentId'} element={<CustomerAppointmentFormContainer/>}/>
                    </Route>
                    <Route path={customerRoutes.Agreements} element={<MainContainer customerInfoOption="agreements"/>}/>
                    <Route path={'users'} element={<VonEmployeesContainer />}>
                        <Route index element={<VonEmployees />} />
                        <Route path={':id/edit'} element={<VonEditEmployeeFormContainer />} />
                        <Route path={'licenses'} element={<VonAdministerLicenseFormContainer />} />
                    </Route>
                    <Route path={customerRoutes.Collaborations} element={<CollaborationsContainer/>}/>
                    <Route path={customerRoutes.Log} element={<CustomerLoggingContainer/>}/>
                    <Route path={customerRoutes.Discounts} element={<DiscountsContainer/>}/>
                    <Route path={customerRoutes.VossDiscounts} element={<SubscriptionsDiscountContainer/>}/>
                    <Route path={'subscriptions/:subscriptionId'} element={<CustomerSubscriptionContainer />} />
                    <Route path={customerRoutes.AdminForms} element={<AdminFormsContainer/>}/>
                    <Route path={'educations/*'} element={<EducationsLayout/>}/>
                    <Route path="orderconfirmationmail/:orderId" element={<OrderConfirmationContainer/>}/>
                    <Route path={customerRoutes.Invoices} element={isFeatureEnabled(FeatureFlags.CustomerInvoiceRemake) ? <CustomerTransactionsContainer/> : <InvoicesContainer/>}/>
                    <Route path={customerRoutes.Consulting} element={<ConsultingContainer/>}/>
                    <Route path={customerRoutes.SendDesktopVersion} element={<SendDesktopVersionContainer/>}/>
                    <Route path={'leads/*'} element={<CustomerLeadsContainer/>}/>
                    <Route path={customerRoutes.relatedCustomers} element={<RelatedCustomersContainer/>}/>
                    <Route path={customerRoutes.Compensation} element={<CompensationContainer/>}/>
                    <Route path={customerRoutes.Campaign} element={<CustomerEmailsContainer/>}/>
                    <Route element={<RequireAuth.RequireReadWriteAuth roles={[UserRoles.SpcsSales]}/>}>
                        <Route path={customerRoutes.orderPlacement} element={<OrderPlacementContainer/>}/>
                    </Route>
                    <Route path={customerRoutes.inyettdetails} element={<InyettContainer/>}/>
                    <Route path={'main'} element={<Navigate to=".." replace/>}/>
                </Route>
            </Route>

            <Route element={<RequireAuth.RequireAdminAuth roles={Object.values(UserRoles)}/>}>
                <Route path={'/settings'} element={<SettingsLayout/>}>
                    <Route path={'internal-customer-admin/termination-reasons/*'}
                           element={<TerminationReasonsLayout/>}/>
                    <Route path={settingsRoutes.Log} element={<CustomerLoggingContainer/>}/>
                    <Route element={<RequireAuth.RequireAdminAuth roles={[UserRoles.User]}/>}>
                        <Route exact path={'adminusers/'} element={<AdminUsersContainer/>}/>
                        <Route path={'adminusers/:type/:id'} element={<AdminusersEditContainer/>}/>
                    </Route>
                    <Route element={<RequireAuth.RequireAdminAuth roles={[UserRoles.BokaMera]}/>}>
                        <Route path={'bokameraadmin'} element={<BokaMeraAdminContainer/>}/>
                    </Route>
                    <Route path={'budget/'} element={<AdminBudgetContainer/>}/>
                    <Route path={'editbudget/:id/:type'} element={<AdminEditBudgetContainer/>}/>
                    <Route element={<RequireAuth.RequireAdminAuth roles={[UserRoles.Compensation]}/>}>
                        <Route exact path={'compensation/'} element={<SettingsCompensationContainer/>}/>
                        <Route path={'compensation/edit/:id/'} element={<SettingsCompensationEditContainer/>}/>
                    </Route>
                    <Route exact path={'customerinfotypes/'} element={<CustomerInfoTypesContainer/>}/>
                    <Route path={'customerinfotypes/edit/:pathId'} element={<CustomerInfoTypesEditContainer/>}/>
                    <Route element={<RequireAuth.RequireAdminAuth roles={[UserRoles.ProductOverview]}/>}>
                        <Route path={'editproductversions'} element={<EditProductVersionContainer/>}/>
                    </Route>
                    <Route element={<RequireAuth.RequireAdminAuth roles={[UserRoles.Eloqua]}/>}>
                        <Route path={'eloqua'} element={<EloquaEditContainer/>}/>
                        <Route path={'eloqua/definitions'} element={<EloquaDefinitionsContainer/>}/>
                    </Route>
                    <Route element={<RequireAuth.RequireAdminAuth roles={[UserRoles.EmailTemplate]}/>}>
                        <Route path={'email-templates/'} element={<EmailTemplatesContainer/>}/>
                        <Route path={'email-template/edit/:id'} element={<EmailTemplateEditContainer/>}/>
                    </Route>
                    <Route element={<RequireAuth.RequireAdminAuth roles={[UserRoles.BankruptcyTermination]}/>}>
                        <Route path={'bankruptcy-termination'} element={<BankruptcyTerminationContainer/>}/>
                        <Route path={'bankruptcy-termination/:jobId'} element={<BankruptcyTerminationDetailContainer/>}/>
                    </Route>
                    <Route element={<RequireAuth.RequireAdminAuth roles={[UserRoles.AOSales]}/>}>
                        <Route exact path={'hittabyra/'} element={<HittaByraContainer/>}/>
                        <Route path={'hittabyra/edit/:id'} element={<HittaByraEditContainer/>}/>
                        <Route path={'hittabyra/addduplicate/:id'} element={<HittaByraAddDuplicateContainer/>}/>
                    </Route>
                    <Route element={<RequireAuth.RequireAdminAuth roles={[UserRoles.PartnerSales]}/>}>
                        <Route exact path={'hittapartner/'} element={<HittaPartnerContainer/>}/>
                        <Route path={'hittapartner/:id'} element={<HittaPartnerEditContainer/>}/>
                    </Route>
                    <Route path={'lead-lists/'} element={<LeadsListsContainer/>}/>
                    <Route element={<RequireAuth.RequireAdminAuth roles={[UserRoles.OrderApproval]}/>}>
                        <Route exact path={'orderapprovalrequests/'}
                               element={<OrderApprovalRequestsContainer/>}/>
                        <Route path={'orderapprovalrequests/:id'}
                               element={<OrderApprovalRequestsEditContainer/>}/>
                    </Route>
                    <Route path={'quotationFaq/'} element={<QuotationFaqContainer/>}/>
                    <Route element={<RequireAuth.RequireAdminAuth roles={[UserRoles.AdministratorSkynet]}/>}>
                        <Route exact path={'release-news/'} element={<ReleaseNewsContainer/>}/>
                        <Route exact path={'release-news-edit/:id'} element={<ReleaseNewsEditContainer/>}/>
                        <Route path={'worker-jobs'} element={<WorkerJobsContainer/>}/>
                        <Route path={'featureflags'} element={<FeatureFlagsContainer/>}/>
                        <Route path={'voss-feature-flags'} element={<VossFeatureFlagsContainer/>}/>
                        <Route path={'system-action-log'} element={<SystemActionLogContainer/>}/>
                        <Route path={'target-groups/*'} element={<TargetGroupsLayout/>}/>
                    </Route>
                    <Route element={<RequireAuth.RequireAdminAuth roles={[UserRoles.AdministratorSkynet]}/>}>
                        <Route path={'configuration'} element={<AppConfigContainer/>}/>
                    </Route>
                    {isFeatureEnabled(FeatureFlags.VSCO_3081_GDPR_USER_INTERFACE) && <Route element={<RequireAuth.RequireAdminAuth roles={[UserRoles.AdministratorSkynet]}/>}>
                        <Route path={settingsRoutes.Gdpr} element={<GdprContainer/>}/>
                    </Route>}
                    <Route element={<RequireAuth.RequireAdminAuth roles={[UserRoles.Invoicing]}/>}>
                        <Route path={'invoicing'} element={<InvoicingContainer/>}/>
                    </Route>
                    <Route path={'discounts/*'}
                           element={isFeatureEnabled(FeatureFlags.DiscountAgreements) ?
                               <DiscountAgreementsLayout
                                   readOnly={!hasAdminAccess(UserRoles.Discounts)}/> :
                               <DiscountLayout/>}/>
                    <Route path={'price-adjustments/*'} element={<PriceAdjustmentLayout/>}/>
                    {isFeatureEnabled(FeatureFlags.VSCO_2458_PACKAGE_MANAGEMENT) && <Route element={<RequireAuth.RequireAdminAuth roles={[UserRoles.PackageManager]}/>}>
                        <Route path={'packages/*'} element={<PackagesLayout/>}/>
                    </Route>}
                    <Route element={<RequireAuth.RequireAdminAuth roles={[UserRoles.PriceSimulation]}/>}>
                        <Route path={'price-simulation/*'} element={<PriceSimulationLayout/>}/>
                    </Route>
                </Route>
            </Route>


            <Route path="/orderconfirmationmail/:pathId/:orderId" element={<OrderConfirmationContainer/>}/>
            <Route path="/emailhistory/:emailActionLogId" element={<EmailHistory/>}/>

            <Route path={'/filebox'} element={<FileBoxContainer/>}/>
            <Route path={'/filebox/:ticketId'} element={<FileBoxTicketDetailsContainer/>}/>
            <Route path={'/createfileboxticket/*'} element={<FileBoxCreateTicketContainer/>}/>

            <Route path={routes.logout} element={<Logout/>}/>
            <Route path={routes.status} element={<StatusContainer/>}/>
            <Route path={'/search'} element={<SearchContainer/>}/>
            <Route path='*' element={<Navigate to={"/search"}/>}/>
            <Route index element={<Navigate to={"/search"}/>}/>
        </Route>
    </Routes>
}

export default AuthenticatedRoutes;